import React from 'react'
import { useSelector } from 'react-redux'

const NotificationBadge = () => {
    const notifications = useSelector(state => state.user.notification_metadata) || {}
    if(notifications.count && notifications.count > 0) {
        return <span className={`badge notification priority-${notifications.maxPriority}`}>{notifications.count}</span>
    }
}

export default NotificationBadge